import styled from 'styled-components';
import {curves, animationDuration} from 'ui/theme';

export const Swipable = styled.div`
  transition: transform ${animationDuration.swipe}ms ${curves.easeOutQuint};
  will-change: transform;

  &.no-transition {
    transition: none;
  }
`;
